import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';

import { FeatureManagementService } from 'src/app/features/feature-management/services';
import { ModalsActions } from 'src/app/features/modals';
import { RootStoreState } from 'src/app/store';

@Component({
    selector: 'app-cancel-signing-modal',
    templateUrl: './cancel-signing-modal.component.html',
    styleUrls: ['./cancel-signing-modal.component.scss'],
    standalone: false
})
export class CancelSigningModalComponent implements OnInit {
  static identifier = 'CancelSigningModalComponent';

  @Input() fixedCategoryTypeCode: string;

  optOutForm: FormGroup;

  constructor(
    private readonly store: Store<RootStoreState.State>,
    private readonly featureManagementService: FeatureManagementService
  ) {}

  get comments() {
    return this.optOutForm.get('comments');
  }

  ngOnInit(): void {
    this.optOutForm = new FormGroup({
      comments: new FormControl(
        null,
        this.fixedCategoryTypeCode === 'CommentsOnly' ? [Validators.required] : null
      ),
    });

    // Force the field to be dirty to display the validation message on page load
    if (this.fixedCategoryTypeCode === 'CommentsOnly') {
      this.comments.markAsDirty();
    }
  }

  getOptOutPackagePayload() {
    return this.fixedCategoryTypeCode === 'CommentsOnly'
      ? {
          ...this.optOutForm.value,
          categoryTypeCode: this.fixedCategoryTypeCode,
        }
      : {
          comments: null,
          categoryTypeCode: this.fixedCategoryTypeCode,
        };
  }

  handleBackButton() {
    this.store.dispatch(ModalsActions.ClearCancelSigningModalComponent());
  }

  handleOptOut() {
    this.optOutForm.markAllAsTouched();

    if (!this.optOutForm.invalid) {
      this.store.dispatch(ModalsActions.CloseDialog());
      this.store.dispatch(ModalsActions.OptOut(this.getOptOutPackagePayload()));
    }
  }
}
